import React, { useEffect, useState } from "react";
import Api from "../../../../shared/api/api";
import "../styles/AdminCronJobs.css";

const CronJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const res = await Api.getCronJobs();
      setJobs(Array.isArray(res) ? res : res.jobs || []);
    } catch (err) {
      console.error("Failed to load CRON jobs:", err);
      setJobs([]);
    }
    setLoading(false);
  };

  const runJobNow = async (id) => {
    try {
      const res = await Api.runCronJobNow(id);
      setMessage(res?.message || "Job triggered.");
      setTimeout(() => setMessage(""), 3000);
      fetchJobs();
    } catch (err) {
      console.error("Failed to run job:", err);
    }
  };

  const toggleJob = async (job) => {
    try {
      await Api.toggleCronJob(job.id);
      fetchJobs();
    } catch (err) {
      console.error("Failed to toggle job:", err);
    }
  };

  return (
    <div className="adminPageContainer">
      <h1>📅 Scheduled Jobs</h1>

      {message && <div className="success-banner">{message}</div>}

      <div className="formSection">
        {loading ? (
          <p>Loading jobs...</p>
        ) : jobs.length === 0 ? (
          <p>No CRON jobs found.</p>
        ) : (
          jobs.map((job) => (
            <div className="settingRow" key={job.name}>
              <div className="settingKey">{job.name}</div>
              <div className="settingValue">
                <code>{job.schedule}</code>
              </div>
              <div className="settingValue">{job.status}</div>
              <div className="settingValue">
                {job.last_run
                  ? new Date(job.last_run).toLocaleString(undefined, { timeZoneName: "short" })
                  : "Never"}
              </div>
              <div className="settingActions">
                <button className="editBtn" onClick={() => toggleJob(job)}>
                  {job.status === "enabled" ? "Disable" : "Enable"}
                </button>
                <button className="saveBtn" onClick={() => runJobNow(job.id)}>
                  Run Now
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CronJobs;
